export default __webpack_public_path__ + "static/media/success.f2dfb552.svg";